import * as React from 'react';
import axios from 'axios';
import { IMedia } from '../../interfaces';
import config from '../../config';
import Film from '../items/Film';
import { connect } from 'react-redux';
import { showModal } from '../../actions/modal';
import Clip from '../items/Clip';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from '../../config/i18next';
import Banner from '../parts/Banner';

interface IState {
    isLoading: boolean,
    last: IMedia[],
    popular: IMedia[],
    favorite: IMedia[],
    filter: string,
    options: any,
    [key: string]: any
}

class Clips extends React.Component<any, any> {
    private _isUnmounted: boolean = false;

    public state: IState = {
        isLoading: true,
        popular: [],
        favorite: [],
        last: [],
        filter: "last",
        options: {
            loop: false,
            margin: 5,
            autoHeight: true,
            nav: true,
            // autoplay: true,
            // autoplayTimeout: 8000,
            responsive: {
                0: {
                    items: 1
                },
                400: {
                    items: 2
                },
                600: {
                    items: 2
                },
                1000: {
                    items: 4
                }
            },
        }
    }

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        try {
            await this.loadFilms(this.state.filter);
        } catch (e) {

        }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    async loadFilms(order: string) {
        $('#carusel6').owlCarousel("destroy");

        this.setState({
            isLoading: true
        }, async () => {
            if (this.state[order].length == 0) {
                let { data } = await axios.get(`${config.site}/${i18n.language}/api/clip/home?order=${order}`);

                if (this._isUnmounted) return;

                this.setState({
                    [order]: data,
                    isLoading: false,
                    filter: order
                }, this.carouselInit);
            } else {
                this.setState({
                    isLoading: false,
                    filter: order
                }, this.carouselInit);
            }
        })
    }

    carouselInit() {
        $('#carusel6').owlCarousel(this.state.options);

        $(window).ready(function () {
            setTimeout(function () {
                $('.owl-carousel').trigger('refresh.owl.carousel');
            }, 50);
        });
    }

    clips() {
        let clips = [];

        for (let i = 0; i < this.state[this.state.filter].length; i += 2) {
            clips.push(
                <div className="item" key={i}>
                    <Clip slide={this.state[this.state.filter][i]} />
                    <Clip slide={this.state[this.state.filter][i + 1]} />
                </div>
            );
        }

        return clips;
    }

    render() {
        const { t } = this.props;

        return (
            <main className="m-index">
                <div className="row">
                    <div className="col-md-9 col-xs-12">
                        <div className="films klips">

                            <nav>
                                <div>
                                    <NavLink to="/clips" className="film"> {t("Клипы")} </NavLink>
                                </div>
                                <div>
                                    <a onClick={async (event: React.MouseEvent) => {
                                        event.preventDefault();
                                        await this.loadFilms("last");
                                    }} className={this.state.filter == "last" ? "active" : ""}> {t("Последние")} </a>

                                    <a onClick={async (event: React.MouseEvent) => {
                                        event.preventDefault();
                                        await this.loadFilms("popular");
                                    }} className={this.state.filter == "popular" ? "active" : ""}> {t("Популярные")} </a>

                                    <a onClick={async (event: React.MouseEvent) => {
                                        event.preventDefault();
                                        if (this.props.auth.isAuthentificated)
                                            await this.loadFilms("favorite");
                                        else
                                            this.props.showModal(t("Для добавления видео в список любимых Вам необходимо авторизоваться."));
                                    }} className={this.state.filter == "favorite" ? "active" : ""}> {t("Любимые")} </a>
                                </div>
                                <div>
                                    <NavLink to="/clips">{this.state[this.state.filter].length > 0 && !this.state.isLoading && t("Показать все")} </NavLink>
                                </div>
                            </nav>

                            {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                            {this.state[this.state.filter].length > 0 && <div className="owl-carousel box_list " id="carusel6">
                                {this.clips()}
                            </div>}
                            {this.state[this.state.filter].length == 0 && !this.state.isLoading && <h3 className="text-center">{t("Ничего не найдено")}</h3>}

                        </div>
                    </div>
                    <div className="col-md-3 col-xs-12">
                        <Banner className="banner_right" place={3} />
                    </div>
                </div>
            </main>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        modal: state.modal,
        auth: state.auth,
    };
}

export default connect(mapStateToProps, { showModal })(withTranslation()(Clips));